// src/Components/AboutUs/index.jsx
import { useRef, useEffect } from "react";
import AboutUsImg from "../../Assets/AboutUs_img.png";
import bindflowLogo from "../../Assets/bindflow_logo.png";
import wisePreventLogo from "../../Assets/wisePrevent_logo.png";
import * as S from "./style";

export const AboutUs = () => {
  const svgRef = useRef(null);

  useEffect(() => {
    const svg = svgRef.current;
    if (!svg) return;

    const t1 = svg.getElementById("ledText1");
    const t2 = svg.getElementById("ledText2");
    const track = svg.getElementById("ledTrack");
    const pattern = svg.getElementById("ledPattern");
    const dot = svg.getElementById("ledDot");

    if (!t1 || !t2 || !track || !pattern || !dot) return;

    // frase do letreiro
    const phrase = "ONDE VOCÊ PRECISAR";
    const long = (phrase.toUpperCase() + " • ").repeat(30);
    t1.textContent = long;
    t2.textContent = long;

    // grid igual ao fundo (coerente com :root no CSS global)
    const gap = 20;    // = var(--dot-gap)
    const radius = 2;  // = var(--dot-radius)  (RAIO, não diâmetro)

    // aplica no pattern (alinha 1:1 com o ::after do .bg-orange)
    pattern.setAttribute("width", gap);
    pattern.setAttribute("height", gap);
    dot.setAttribute("cx", gap / 2);
    dot.setAttribute("cy", gap / 2);
    dot.setAttribute("r", radius);

    // loop perfeito: mede o texto e define a distância
    const layout = () => {
      const w = t1.getBBox().width;
      t2.setAttribute("x", String(w));
      track.style.setProperty("--distance", `${w}px`);
    };
    layout();

    const onR = () => {
      clearTimeout(window.__ledR);
      window.__ledR = setTimeout(layout, 120);
    };
    window.addEventListener("resize", onR);
    setTimeout(layout, 200);

    return () => window.removeEventListener("resize", onR);
  }, []);

  return (
    <S.Content id="aboutUs">
      {/* === PAINEL DE LED (cobre a .bg-orange, limitado pela faixa abaixo) === */}
      <div className="led-layer" style={{ "--speed": "24s" }}>
        <svg ref={svgRef} aria-hidden="true">
          <defs>
            {/* Pattern com o MESMO gap/raio das bolinhas do fundo */}
            <pattern id="ledPattern" patternUnits="userSpaceOnUse" width="20" height="20" x="0" y="0">
              {/* cor do LED aceso (pode trocar) */}
              <circle id="ledDot" cx="10" cy="10" r="2" fill="#FFF8F0" opacity="1" />
            </pattern>

            {/* Faixa onde o texto aparece (ajuste y/height conforme desejar) */}
            <clipPath id="ledBand" clipPathUnits="userSpaceOnUse">
              <rect x="0" y="40" width="100%" height="160" />
            </clipPath>

            {/* Texto branco revela o pattern dentro da faixa */}
            <mask id="ledMask">
              <rect width="100%" height="100%" fill="black" />
              <g className="led-track" id="ledTrack" fill="white" clipPath="url(#ledBand)">
                <text className="led-text" id="ledText1" x="0" y="50%" />
                <text className="led-text" id="ledText2" x="0" y="50%" />
              </g>
            </mask>
          </defs>

          {/* LEDs acesos alinhados ao grid do fundo, visíveis só dentro do texto */}
          <rect width="100%" height="100%" fill="url(#ledPattern)" mask="url(#ledMask)" />
        </svg>
      </div>
      {/* === /PAINEL DE LED === */}

      <S.Wrapper>
        <S.Card>
          <S.TextBox>
            <h2>Sobre a WisePrevent</h2>

            <p>
              O WisePrevent é uma solução desenvolvida pela Bindflow, empresa de
              tecnologia com crescimento de mais de 400% nos últimos dois anos.
            </p>

            <p>
              No portfólio, marcas como L’Oréal, Rumo e Condor, além de cases em
              setores críticos de energia, logística e indústria.
            </p>

            <img src={bindflowLogo} alt="" />
          </S.TextBox>

          <img src={AboutUsImg} alt="" />
        </S.Card>

        <S.BottomCard>
          <h3>Ou você prevê a falha<br />ou ela te surpreende</h3>

          <p>A sua operação não precisa mais conviver com o risco</p>

          <S.ActionBtn
            className="action-btn"
            onClick={() => window.open("https://wa.me/5541999981633", "_blank")}
          >
            Agende uma demonstração
          </S.ActionBtn>

          <img src={wisePreventLogo} alt="" />
        </S.BottomCard>
      </S.Wrapper>
    </S.Content>
  );
};
